import { CircuitoResoData } from "./CircuitoResoData";
import { useState, useContext, useEffect } from "react";
import { PortalContext } from "../../../context/Provider";
import { setCircuitoReso } from "../../../context/Actions/turnos/estudioTurnos";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import HeaderModal from "../headerModal/headerModal";
import "./Circuito.css";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../InputV1/InputV1";

const CircuitoReso = ({
  titulo,
  dissmiss,
  danger,
  texto,
  dataBioseguridad,
}) => {
  const { estudioTurnosDispatch } = useContext(PortalContext);
  // Toaster Global
  const { toasterDispatch } = useContext(GlobalContext);
  const [circuitoFiltrado, setCircuitoFiltrado] = useState({
    contraste: null,
    peso: dataBioseguridad.peso ? dataBioseguridad.peso : null,
    renal: dataBioseguridad.flgInsuficienciaRenal?.toString() ?? null,
    labFuncionRenal: dataBioseguridad.flgLabFuncionRenal?.toString() ?? null,
    marcaPasos: dataBioseguridad.flgMarcapasos?.toString() ?? null,
    flgImplanteMetalico:
      dataBioseguridad.flgImplanteMetalico?.toString() ?? null,
    marcaMarcapasos: dataBioseguridad.marcaMarcapasos
      ? dataBioseguridad.marcaMarcapasos
      : "",
    modeloMarcapasos: dataBioseguridad.modeloMarcapasos
      ? dataBioseguridad.modeloMarcapasos
      : "",
    fechaMarcapasos:
      dataBioseguridad.fechaMarcapasos &&
      dataBioseguridad.fechaMarcapasos !== "0001-01-01T00:00:00"
        ? dataBioseguridad.fechaMarcapasos.substring(0, 10) // recorta YYYY-MM-DD
        : "",
    materialImpMet: dataBioseguridad.materialImpMet
      ? dataBioseguridad.materialImpMet
      : "",
    ubicacionImpMet: dataBioseguridad.ubicacionImpMet
      ? dataBioseguridad.ubicacionImpMet
      : "",
    fechaImpMet:
      dataBioseguridad.fechaImpMet &&
      dataBioseguridad.fechaImpMet !== "0001-01-01T00:00:00"
        ? dataBioseguridad.fechaImpMet.substring(0, 10) // recorta YYYY-MM-DD
        : "",
  });

  const [camposObligatorios, setCamposObligatorios] = useState({});
  const [errores, setErrores] = useState([]);

  useEffect(() => {
    setCamposObligatorios({
      contraste: true,
      peso: true,
      renal: circuitoFiltrado.contraste === "1",
      labFuncionRenal: circuitoFiltrado.renal === "1",
      marcaPasos: true,
      flgImplanteMetalico: true,
    });
  }, [circuitoFiltrado]);

  const onChangeCheck = (e) => {
    const { name, value } = e.target;
    setCircuitoFiltrado((prev) => {
      let updated = {
        ...prev,
        [name]: value, // ✅ guardamos boolean
      };

      // Si no tiene datos en la base reseteo los inputs dependientes
      if (dataBioseguridad === null || dataBioseguridad === "") {
        // lógica de reseteo de dependencias
        if (name === "contraste" && value === "2") {
          updated.renal = null;
          updated.labFuncionRenal = null;
        }

        if (name === "marcaPasos" && value === "2") {
          updated.marcaMarcapasos = "";
          updated.modeloMarcapasos = "";
          updated.fechaMarcapasos = "";
        }

        if (name === "flgImplanteMetalico" && value === "2") {
          updated.materialImpMet = "";
          updated.ubicacionImpMet = "";
          updated.fechaImpMet = "";
        }
      }

      return updated;
    });
    setErrores((prev) => prev.filter((campo) => campo !== name));
  };

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setCircuitoFiltrado((prev) => ({
      ...prev,
      [name]: parseInt(value) >= 0 ? parseInt(value) : "", // ✅ guardamos number o vacío
    }));
    setErrores((prev) => prev.filter((campo) => campo !== name));
  };

  const onChangeMultiInput = (e) => {
    const { name, value } = e.target;
    setCircuitoFiltrado((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrores((prev) => prev.filter((campo) => campo !== name));
  };

  const onClickVolverCirc = () => {
    setCircuitoFiltrado(CircuitoResoData);
    dissmiss();
  };

  const validarCampos = () => {
    const errores = [];

    Object.entries(camposObligatorios).forEach(([campo, esObligatorio]) => {
      if (esObligatorio) {
        const valor = circuitoFiltrado[campo];

        // ❌ chequeo de "vacío"
        if (
          valor === null ||
          valor === "" ||
          valor === undefined ||
          valor === "0" // si usás "0" como "sin respuesta"
        ) {
          errores.push(campo);
        }
      }
    });

    if (errores.length > 0) {
      setErrores(errores);
      return false;
    }

    return errores.length === 0;
  };

  const mapToBool = (value) => {
    if (value === "1") return true;
    if (value === "2") return false;
    return false;
  };

  const onClickBusqCirc = () => {
    if (validarCampos()) {
      const dto = {
        contraste: mapToBool(circuitoFiltrado.contraste),
        peso: circuitoFiltrado.peso,
        renal: mapToBool(circuitoFiltrado.renal),
        labFuncionRenal: mapToBool(circuitoFiltrado.labFuncionRenal),
        marcaPasos: mapToBool(circuitoFiltrado.marcaPasos),
        flgImplanteMetalico: mapToBool(circuitoFiltrado.flgImplanteMetalico),
        marcaMarcapasos: circuitoFiltrado.marcaMarcapasos && circuitoFiltrado.marcaPasos === "1" ? circuitoFiltrado.marcaMarcapasos : "",
        modeloMarcapasos: circuitoFiltrado.modeloMarcapasos && circuitoFiltrado.marcaPasos === "1" ? circuitoFiltrado.modeloMarcapasos : "",
        fechaMarcapasos: circuitoFiltrado.fechaMarcapasos && circuitoFiltrado.marcaPasos === "1" ? circuitoFiltrado.fechaMarcapasos : "0001-01-01",
        materialImpMet: circuitoFiltrado.materialImpMet && circuitoFiltrado.flgImplanteMetalico === "1" ? circuitoFiltrado.materialImpMet : "",
        ubicacionImpMet: circuitoFiltrado.ubicacionImpMet && circuitoFiltrado.flgImplanteMetalico === "1" ? circuitoFiltrado.ubicacionImpMet : "",
        fechaImpMet: circuitoFiltrado.fechaImpMet && circuitoFiltrado.flgImplanteMetalico === "1" ? circuitoFiltrado.fechaImpMet : "0001-01-01",
      };

      setCircuitoReso({
        ...dto,
        flgForm: true,
      })(estudioTurnosDispatch);
    } else {
      showToaster(
        {
          texto: "Complete las preguntas!",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} danger={danger} />
      <div className="ptur-circuito-bodyModal">
        <div className="ptur-circuito-tituloDesc">
          <p className="rb18l titulo-circuito">{texto}</p>
        </div>
        <div className="ptur-circuito-box">
          <div className="ptur-circuito-boxPreguntas">
            <p className="ptur-circuito-preguntaDesc rb14l">
              ¿La orden médica indica con contraste o Gadolinio?{" "}
              {errores.includes("contraste") && (
                <span className="c-danger rb18b">*</span>
              )}
            </p>
            <div className="ptur-circuito-checkboxs">
              <span>
                <InputV1
                  id={"cont1"}
                  name={"contraste"}
                  onClick={onChangeCheck}
                  value={"1"}
                  inputType="check"
                  checkboxStr={"Sí"}
                  className={`fake-radio ptur-circuito-check ${
                    errores.includes("contraste") ? "input-error" : ""
                  }`}
                  noHeight={true}
                  checked={circuitoFiltrado.contraste === "1"}
                />
              </span>
              <span>
                <InputV1
                  id={"cont2"}
                  name={"contraste"}
                  onClick={onChangeCheck}
                  value={"2"}
                  inputType="check"
                  checkboxStr={"No"}
                  className={`fake-radio ptur-circuito-check ${
                    errores.includes("contraste") ? "input-error" : ""
                  }`}
                  noHeight={true}
                  checked={circuitoFiltrado.contraste === "2"}
                />
              </span>
            </div>
          </div>
          {circuitoFiltrado.contraste === "1" && (
            <div className="ptur-circuito-boxPreguntas">
              <p className="ptur-circuito-preguntaDesc rb14l">
                ¿Tiene insuficiencia renal?{" "}
                {errores.includes("renal") && (
                  <span className="c-danger rb18b">*</span>
                )}
              </p>
              <div className="ptur-circuito-checkboxs">
                <span>
                  <InputV1
                    id={"ren1"}
                    name={"renal"}
                    onClick={onChangeCheck}
                    value={"1"}
                    inputType="check"
                    checkboxStr={"Sí"}
                    className={`fake-radio ptur-circuito-check ${
                      errores.includes("renal") ? "input-error" : ""
                    }`}
                    noHeight={true}
                    checked={circuitoFiltrado.renal === "1"}
                  />
                </span>
                <span>
                  <InputV1
                    id={"ren2"}
                    name={"renal"}
                    onClick={onChangeCheck}
                    value={"2"}
                    inputType="check"
                    checkboxStr={"No"}
                    className={`fake-radio ptur-circuito-check ${
                      errores.includes("renal") ? "input-error" : ""
                    }`}
                    noHeight={true}
                    checked={circuitoFiltrado.renal === "2"}
                  />
                </span>
              </div>
            </div>
          )}
          {circuitoFiltrado.contraste === "1" &&
            circuitoFiltrado.renal === "1" && (
              <div className="ptur-circuito-boxPreguntas">
                <p className="ptur-circuito-preguntaDesc rb14l">
                  ¿Realizó un laboratorio de Función Renal en los últimos 30
                  días?{" "}
                  {errores.includes("labFuncionRenal") && (
                    <span className="c-danger rb18b">*</span>
                  )}
                </p>
                <div className="ptur-circuito-checkboxs">
                  <span>
                    <InputV1
                      id={"labFnRen1"}
                      name={"labFuncionRenal"}
                      onClick={onChangeCheck}
                      value={"1"}
                      inputType="check"
                      checkboxStr={"Sí"}
                      className={`fake-radio ptur-circuito-check ${
                        errores.includes("labFuncionRenal") ? "input-error" : ""
                      }`}
                      noHeight={true}
                      checked={circuitoFiltrado.labFuncionRenal === "1"}
                    />
                  </span>
                  <span>
                    <InputV1
                      id={"labFnRen2"}
                      name={"labFuncionRenal"}
                      onClick={onChangeCheck}
                      value={"2"}
                      inputType="check"
                      checkboxStr={"No"}
                      className={`fake-radio ptur-circuito-check ${
                        errores.includes("labFuncionRenal") ? "input-error" : ""
                      }`}
                      noHeight={true}
                      checked={circuitoFiltrado.labFuncionRenal === "2"}
                    />
                  </span>
                </div>
              </div>
            )}

          <div className="ptur-circuito-boxPreguntas">
            <p className="ptur-circuito-preguntaDesc rb14l">
              ¿Cuánto pesa?{" "}
              {errores.includes("peso") && (
                <span className="c-danger rb18b">*</span>
              )}
            </p>
            <div className="ptur-circuito-input">
              <input
                type="number"
                name={"peso"}
                onChange={(e) => onChangeInput(e)}
                value={circuitoFiltrado.peso}
                className={"ptur-input-peso inputNonScroll"}
                style={{
                  border:
                    errores.includes("peso") && "2px solid var(--color-danger)",
                }}
              />
              <p>kg</p>
            </div>
          </div>

          <div className="ptur-circuito-boxPreguntas">
            <p className="ptur-circuito-preguntaDesc rb14l">
              ¿Tiene Marcapasos?{" "}
              {errores.includes("marcaPasos") && (
                <span className="c-danger rb18b">*</span>
              )}
            </p>
            <div className="ptur-circuito-checkboxs">
              <span>
                <InputV1
                  id={"mp1"}
                  name={"marcaPasos"}
                  onClick={onChangeCheck}
                  value={"1"}
                  inputType="check"
                  checkboxStr={"Sí"}
                  className={`fake-radio ptur-circuito-check ${
                    errores.includes("marcaPasos") ? "input-error" : ""
                  }`}
                  noHeight={true}
                  checked={circuitoFiltrado.marcaPasos === "1"}
                />
              </span>
              <span>
                <InputV1
                  id={"mp2"}
                  name={"marcaPasos"}
                  onClick={onChangeCheck}
                  value={"2"}
                  inputType="check"
                  checkboxStr={"No"}
                  className={`fake-radio ptur-circuito-check ${
                    errores.includes("marcaPasos") ? "input-error" : ""
                  }`}
                  noHeight={true}
                  checked={circuitoFiltrado.marcaPasos === "2"}
                />
              </span>
            </div>
          </div>
          {circuitoFiltrado.marcaPasos === "1" && (
            <div className="ptur-circuito-input-desc">
              <div className="ptur-desc-item">
                <p className="ptur-input-txt rb14l">Marca</p>
                <input
                  type="text"
                  name={"marcaMarcapasos"}
                  onChange={(e) => onChangeMultiInput(e, "marcaMarcapasos")}
                  value={circuitoFiltrado.marcaMarcapasos}
                  className={"ptur-input-descripcion"}
                  autoComplete="off"
                />
              </div>
              <div className="ptur-desc-item">
                <p className="ptur-input-txt rb14l">Modelo</p>
                <input
                  type="text"
                  name={"modeloMarcapasos"}
                  onChange={(e) => onChangeMultiInput(e, "modeloMarcapasos")}
                  value={circuitoFiltrado.modeloMarcapasos}
                  className={"ptur-input-descripcion"}
                  autoComplete="off"
                />
              </div>
              <div className="ptur-desc-item">
                <p className="ptur-input-txt rb14l">Fecha colocación</p>
                <input
                  type="date"
                  name={"fechaMarcapasos"}
                  onChange={(e) => onChangeMultiInput(e, "fechaMarcapasos")}
                  value={circuitoFiltrado.fechaMarcapasos}
                  className={"ptur-input-descripcion"}
                />
              </div>
            </div>
          )}

          <div className="ptur-circuito-boxPreguntas">
            <p className="ptur-circuito-preguntaDesc rb14l">
              ¿Tiene Implantes Metálicos?{" "}
              {errores.includes("flgImplanteMetalico") && (
                <span className="c-danger rb18b">*</span>
              )}
            </p>
            <div className="ptur-circuito-checkboxs">
              <span>
                <InputV1
                  id={"impMet1"}
                  name={"flgImplanteMetalico"}
                  onClick={onChangeCheck}
                  value={"1"}
                  inputType="check"
                  checkboxStr={"Sí"}
                  className={`fake-radio ptur-circuito-check ${
                    errores.includes("flgImplanteMetalico") ? "input-error" : ""
                  }`}
                  noHeight={true}
                  checked={circuitoFiltrado.flgImplanteMetalico === "1"}
                />
              </span>
              <span>
                <InputV1
                  id={"impMet2"}
                  name={"flgImplanteMetalico"}
                  onClick={onChangeCheck}
                  value={"2"}
                  inputType="check"
                  checkboxStr={"No"}
                  className={`fake-radio ptur-circuito-check ${
                    errores.includes("flgImplanteMetalico") ? "input-error" : ""
                  }`}
                  noHeight={true}
                  checked={circuitoFiltrado.flgImplanteMetalico === "2"}
                />
              </span>
            </div>
          </div>
          {circuitoFiltrado.flgImplanteMetalico === "1" && (
            <div className="ptur-circuito-input-desc">
              <div className="ptur-desc-item">
                <p className="ptur-input-txt rb14l">Material</p>
                <input
                  type="text"
                  name={"materialImpMet"}
                  onChange={(e) => onChangeMultiInput(e, "materialImpMet")}
                  value={circuitoFiltrado.materialImpMet}
                  className={`ptur-input-descripcion ${
                    camposObligatorios?.materialImpMet && "inputObligatorio"
                  }`}
                  autoComplete="off"
                />
              </div>
              <div className="ptur-desc-item">
                <p className="ptur-input-txt rb14l">Ubicación</p>
                <input
                  type="text"
                  name={"ubicacionImpMet"}
                  onChange={(e) => onChangeMultiInput(e, "ubicacionImpMet")}
                  value={circuitoFiltrado.ubicacionImpMet}
                  className={"ptur-input-descripcion"}
                  autoComplete="off"
                />
              </div>
              <div className="ptur-desc-item">
                <p className="ptur-input-txt rb14l">Fecha colocación</p>
                <input
                  type="date"
                  name={"fechaImpMet"}
                  onChange={(e) => onChangeMultiInput(e, "fechaImpMet")}
                  value={circuitoFiltrado.fechaImpMet}
                  className={"ptur-input-descripcion"}
                />
              </div>
            </div>
          )}
        </div>
        <div className="ptur-circuito-boxBtn">
          <button
            className="ptur-circuito-btnVolver c-latex30 rb16m"
            onClick={onClickVolverCirc}
          >
            Volver
          </button>
          <button
            className="ptur-circuito-btnBusq c-white rb16m"
            onClick={onClickBusqCirc}
          >
            Buscar turnos
          </button>
        </div>
      </div>
    </>
  );
};

export default CircuitoReso;
